import React from 'react';
import { useNavigate } from 'react-router-dom';
import RmsBreadcrumb from './RmsBreadcrumb';

/**
 * HeaderContainer
 * Sticky header wrapper that holds the brand row and question header.
 * It also exposes a ref (headerRef) used by useLayoutMetrics to measure height.
 *
 * Design notes:
 * - We apply a solid white background so that scrolling content never shows through
 *   behind the sticky header, ensuring consistent readability.
 * - We add a soft white box-shadow at the bottom edge to create a subtle fade-out
 *   over the top of the scrolling content, visually separating the header from
 *   the page body without a harsh divider line.
 */
export default function HeaderContainer({ headerRef, children, backTo = null, backLabel = 'Back to Overview', breadcrumbItems = null }) {
  const navigate = useNavigate();
  return (
    <div
      ref={headerRef}
      className="sticky top-0 left-0 right-0 z-30 rms-header bg-white"
      style={{
        boxShadow:
          '0 24px 36px rgba(255,255,255,0.95), 0 12px 20px rgba(255,255,255,0.85)',
      }}
    >
      <div className="w-full px-6 md:px-10 py-10">
        <div className="w-full md:w-1/2 mx-auto">
          {/* Optional breadcrumb row (preferred for post-account forms):
             - Appears in the same row area where the brand/logo would.
             - Left aligned, shows "Overview / Current Form".
           */}
          {Array.isArray(breadcrumbItems) && breadcrumbItems.length > 0 ? (
            <RmsBreadcrumb items={breadcrumbItems} />
          ) : backTo ? (
            <div className="mb-4">
              <button
                type="button"
                className="inline-flex items-center text-sm text-primary hover:underline"
                onClick={() => navigate(backTo)}
                aria-label={backLabel}
              >
                <svg viewBox="0 0 24 24" className="w-5 h-5" aria-hidden="true">
                  <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {backLabel}
              </button>
            </div>
          ) : null}
          {children}
        </div>
      </div>
    </div>
  );
}


